import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { VmeCommonModule } from '../../vme-common.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobAlertSettingsEditComponent } from './job-alert-settings-edit.component';

@NgModule({
  imports: [VmeCommonModule, VmeDirectivesModule, VmePipesModule],
  declarations: [JobAlertSettingsEditComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [JobAlertSettingsEditComponent],
})
export class JobAlertSettingsEditModule {}
